export const DEFAULT_FORNITORE = {
    "persona_fisica": {
        "pf_codice_fiscale": "",  // used for internal logic only, will be removed before API call
        "cognome": "",
        "nome": "",
        "sesso": "",
        "data_di_nascita": "",
        "comune_nascita": "",
        "provincia_nascita": "",
        "comune_domicilio": "",
        "provincia_domicilio": "",
        "indirizzo_domicilio": "",
        "cap_domicilio": ""
    },
    "partita_iva": {
        "piva_codice_fiscale": "",  // used for internal logic only, will be removed before API call
        "denominazione": "",
        "comune_sede": "",
        "provincia_sede": "",
        "indirizzo_sede": "",
        "cap_sede": "",
        "comune_domicilio": "",
        "provincia_domicilio": "",
        "indirizzo_domicilio": "",
        "cap_domicilio": ""
    },
    "codice_fiscale": "",  // this is the fields that will be used for API call
    "flag_origine": "E",
    "telefono_intermediario": "",
    "email_intermediario": ""
};
